import React from 'react';

import { Code } from 'src/components/code/Code';
import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import { HeaderTab } from 'src/components/common/headerTab/HeaderTab';
import { collapseToShellCommand } from 'src/components/publishSchema/continuousIntegrationTab/ContinuousIntegrationTab';
import { DocsRouter } from 'src/lib/routers';

interface Props {
  graphId: string;
  listId: string;
  linkedVariantId?: string;
}

export const PersistedQueryListPublishInfo = ({
  graphId,
  linkedVariantId,
  listId,
}: Props) => {
  const roverOperationsPublishCommand = collapseToShellCommand(
    'rover persisted-queries publish',
    ...(linkedVariantId
      ? [linkedVariantId]
      : [`--graph-id ${graphId}`, `--list-id "${listId}"`]),
    '--manifest ./persisted-query-manifest.json',
  );

  return (
    <>
      <p>
        Publish a manifest of operations to this list using one of the following
        methods.{' '}
        <ClickableText
          className="text-link hover:underline"
          as="a"
          rel="noopener noreferrer"
          target="_blank"
          href={DocsRouter.path('PersistedQueries')}
        >
          See our docs
        </ClickableText>{' '}
        for more details and advanced configurations as well.
      </p>
      <HeaderTab
        tabName="Rover"
        tabID="rover"
        isActive={() => true}
        onClick={() => {}}
      />
      <Code code={roverOperationsPublishCommand} showCopyButton />
    </>
  );
};
